import request from '@/utils/request';

const PATH = '/business/store/event';

export const getBusinessStoreEventList = (params: any) => request({
  url: PATH,
  method: 'get',
  params: {
    ...params,
    page: params.page - 1,
  },
});

export const getBusinessStoreEvent = (idx: any) => request({
  url: `${PATH}/${idx}`,
  method: 'get',
});

export const addBusinessStoreEvent = (data: any) => request({
  url: PATH,
  method: 'post',
  data,
});

export const updateBusinessStoreEvent = (idx: any, data: any) => request({
  url: `${PATH}/${idx}`,
  method: 'put',
  data,
});

export const deleteBusinessStoreEvent = (idx: any) => request({
  url: `${PATH}/${idx}`,
  method: 'delete',
});
